import type { FieldHtmlNameType } from '@onshape/www-inertia';
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import BaseProgressiveProfileDefinition from '../BaseProgressiveProfileDefinition';
import type { ProgressRule } from '../ProgressRule';

/** Fills out common fields like name, email and company name. */
export default class CommonPreFilledProgressiveProfile extends BaseProgressiveProfileDefinition {
  private readonly branchField: FieldHtmlNameType = FieldHtmlNameUtil.email;

  private readonly progressRules: readonly ProgressRule[] = [];

  private readonly alwaysShownFields: readonly FieldHtmlNameType[] = [];

  public getProgressRules(): readonly ProgressRule[] {
    return this.progressRules;
  }

  public getBranchField(): FieldHtmlNameType {
    return this.branchField;
  }

  public getAlwaysShownFields(): readonly FieldHtmlNameType[] {
    return this.alwaysShownFields;
  }
}
